// extracted by mini-css-extract-plugin
module.exports = {"input_Rectangle":"input_Rectangle___3jsQU","input_Rectangle_Icon":"input_Rectangle_Icon___3WC2m","title":"title___1d8xJ"};